<template>
  <form class="contact-form-container" @submit.prevent="sendMessage">
    <div class="contact-form-container__grid">
      <div class="contact-form-container__field">
        <label for="name">Imię*</label>
        <input
            type="text"
            class="contact-form-container__input"
            name="name"
            id="name"
            placeholder="Np. Anna"
            v-model="contactName"
            required
        >
      </div>

      <div class="contact-form-container__field">
        <label for="email">Adres e-mail*</label>
        <input
            type="email"
            class="contact-form-container__input"
            name="email"
            id="email"
            placeholder="Np. anna@firma.pl"
            v-model="contactEmail"
            required
        >
      </div>

      <div class="contact-form-container__field">
        <label for="tel">Numer telefonu</label>
        <input
            type="tel"
            class="contact-form-container__input"
            name="tel"
            id="tel"
            placeholder="Np. 500 600 700"
            v-model="contactPhone"
        >
      </div>

      <div class="contact-form-container__field">
        <label for="subject">Temat wiadomości</label>
        <input
            type="text"
            class="contact-form-container__input"
            name="subject"
            id="subject"
            placeholder="Np. Współpraca"
            v-model="contactSubject"
        >
      </div>
    </div>

    <div class="contact-form-container__field">
      <label for="content">Treść wiadomości*</label>
      <textarea
          name="content"
          id="content"
          class="contact-form-container__ta"
          placeholder="Opisz krótko, w czym możemy pomóc..."
          v-model="contactMessage"
          required
      ></textarea>
    </div>

    <div class="contact-form-container__footer">
      <span
          ref="contactFormAlert"
          :class="[
          'contact-form-container__alert',
          alertType ? `contact-form-container__alert--${alertType}` : ''
        ]"
      ></span>
      <button type="submit" :disabled="isSending">
        {{ isSending ? 'Wysyłanie...' : 'Wyślij wiadomość' }}
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ContactForm',
  data() {
    return {
      contactName: '',
      contactPhone: '',
      contactEmail: '',
      contactSubject: '',
      contactMessage: '',
      isSending: false,
      alertType: ''
    };
  },
  methods: {
    sendMessage() {
      this.$refs.contactFormAlert.textContent = '';
      this.alertType = '';

      if (!this.contactName || !this.contactEmail || !this.contactMessage) {
        this.alertType = 'error';
        this.$refs.contactFormAlert.textContent = 'Uzupełnij wymagane pola oznaczone gwiazdką.';
        return;
      }

      this.isSending = true;

      const ob = {
        from_id: 2,
        to_id: 1,
        title: `${this.contactName} | ${this.contactEmail}`,
        content: `${this.contactSubject} | ${this.contactPhone} | ${this.contactMessage}`
      };

      axios.post('/Message', ob)
          .then(res => {
            if (String(res.status).charAt(0) === '2') {
              this.alertType = 'success';
              this.$refs.contactFormAlert.textContent = 'Pomyślnie wysłano wiadomość. Wkrótce się z Tobą skontaktujemy.';
              this.contactName = '';
              this.contactPhone = '';
              this.contactEmail = '';
              this.contactSubject = '';
              this.contactMessage = '';
            } else {
              this.alertType = 'error';
              this.$refs.contactFormAlert.textContent = 'Nie udało się wysłać wiadomości. Spróbuj ponownie.';
            }
          })
          .catch(() => {
            this.alertType = 'error';
            this.$refs.contactFormAlert.textContent = 'Wystąpił błąd podczas wysyłania wiadomości.';
          })
          .finally(() => {
            this.isSending = false;
          });
    }
  }
};
</script>

<style scoped lang="scss">
.contact-form-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      font-size: 1.3rem;
      font-weight: 600;
      color: #374151;
    }
  }

  &__input,
  &__ta {
    border: 1px solid #d1d5db;
    border-radius: 10px;
    padding: 11px 12px;
    font-size: 1.4rem;
    color: #111827;
    background: #fff;
    outline: none;
    transition: border-color .2s ease, box-shadow .2s ease;
  }

  &__input:focus,
  &__ta:focus {
    border-color: #10b981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.14);
  }

  &__ta {
    min-height: 160px;
    resize: vertical;
    line-height: 1.5;
  }

  &__footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    button {
      background: #10b981;
      color: #fff;
      border: none;
      border-radius: 10px;
      padding: 10px 16px;
      font-weight: 600;
      font-size: 1.4rem;
      cursor: pointer;
      transition: background-color .2s ease, transform .15s ease;
    }

    button:hover {
      background: #059669;
      transform: translateY(-1px);
    }

    button:disabled {
      background: #9ca3af;
      cursor: not-allowed;
      transform: none;
    }
  }

  &__alert {
    min-height: 20px;
    font-size: 1.3rem;

    &--success {
      color: #047857;
    }

    &--error {
      color: #dc2626;
    }
  }
}

@media (max-width: 720px) {
  .contact-form-container {
    &__grid {
      grid-template-columns: 1fr;
    }

    &__footer {
      button {
        width: 100%;
      }
    }
  }
}
</style>